(function () {
  if (!document.body.classList.contains('ntx-brand')) return;

  var hdr = document.getElementById('ntx-hdr');
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle('stuck', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (document.body.classList.contains('template-policy')) {
      hdr.classList.add('stuck');
    }
  }

  var burger = document.getElementById('ntx-burger');
  var menu = document.getElementById('ntx-menu');
  if (burger && menu) {
    var setMenu = function (open) {
      menu.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };

    burger.addEventListener('click', function () {
      setMenu(!menu.classList.contains('open'));
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        setMenu(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) setMenu(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760 && menu.classList.contains('open')) setMenu(false);
    });
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }
  );

  var rvEls = document.querySelectorAll('.ntx-brand .rv');
  rvEls.forEach(function (el) {
    io.observe(el);
  });

  function revealInView() {
    rvEls.forEach(function (el) {
      if (el.classList.contains('in')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('in');
        io.unobserve(el);
      }
    });
  }

  revealInView();
  window.addEventListener('load', revealInView, { passive: true });
  window.addEventListener('resize', revealInView, { passive: true });
  window.addEventListener(
    'orientationchange',
    function () {
      setTimeout(revealInView, 150);
    },
    { passive: true }
  );
  setTimeout(function () {
    rvEls.forEach(function (el) {
      el.classList.add('in');
    });
  }, 2200);

  var v = document.getElementById('ntx-hero-vid');
  if (v) {
    var markReady = function () {
      if (v.videoWidth) v.classList.add('ready');
    };
    v.addEventListener('loadeddata', markReady);
    if (v.readyState >= 2) markReady();
    v.addEventListener('error', function () {
      v.remove();
    }, true);

    // Attach the hero video only after the page has loaded, and skip it for Data Saver / reduced motion.
    var startVideo = function () {
      var saveData = navigator.connection && navigator.connection.saveData;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (saveData || reduce) {
        v.remove();
        return;
      }
      var src = v.getAttribute('data-src');
      if (!src) return;
      v.removeAttribute('data-src');
      v.preload = 'auto';
      v.src = src;
      var pauseBtn = document.getElementById('ntx-play');
      if (pauseBtn && pauseBtn.dataset.p === '1') return; // visitor already paused the hero
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    if (document.readyState === 'complete') {
      setTimeout(startVideo, 300);
    } else {
      window.addEventListener('load', function () {
        setTimeout(startVideo, 300);
      });
    }

    var mb = document.getElementById('ntx-mute');
    var pb = document.getElementById('ntx-play');
    if (mb) {
      mb.addEventListener('click', function () {
        if (!v.isConnected) return;
        v.muted = !v.muted;
        mb.style.borderColor = v.muted ? '' : 'var(--red)';
      });
    }
    if (pb) {
      pb.addEventListener('click', function () {
        var f = document.querySelector('.ntx-hero .fallback');
        var paused = pb.dataset.p === '1';
        if (v.isConnected) {
          if (paused) v.play();
          else v.pause();
        }
        if (f) f.style.animationPlayState = paused ? 'running' : 'paused';
        document.querySelectorAll('.ntx-hero .sparks i, .ntx-hero .laser, .ntx-hero .hit').forEach(function (el) {
          el.style.animationPlayState = paused ? 'running' : 'paused';
        });
        pb.dataset.p = paused ? '0' : '1';
        pb.innerHTML = paused
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5v14M15 5v14"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
      });
    }
  }

  var sparks = document.getElementById('ntx-sparks');
  if (sparks && !sparks.dataset.built) {
    sparks.dataset.built = '1';
    for (var i = 0; i < 22; i++) {
      var s = document.createElement('i');
      var a = Math.random() * Math.PI - Math.PI;
      var d = 40 + Math.random() * 130;
      s.style.setProperty('--x', (Math.cos(a) * d).toFixed(0) + 'px');
      s.style.setProperty('--y', (Math.abs(Math.sin(a)) * -d * 0.7).toFixed(0) + 'px');
      s.style.animationDelay = (Math.random() * 2.6).toFixed(2) + 's';
      s.style.animationDuration = (1.8 + Math.random() * 1.6).toFixed(2) + 's';
      sparks.appendChild(s);
    }
  }

  document.querySelectorAll('.ntx-gallery .chip[data-f]').forEach(function (c) {
    c.addEventListener('click', function () {
      document.querySelectorAll('.ntx-gallery .chip[data-f]').forEach(function (x) {
        x.classList.remove('on');
      });
      c.classList.add('on');
      var f = c.dataset.f;
      document.querySelectorAll('.ntx-gallery .g-item').forEach(function (g) {
        g.classList.toggle('hide', f !== 'all' && g.dataset.c !== f);
      });
    });
  });

  // Third-party embeds ship light-theme text. Lighten only the labels that
  // land on our dark background — anything sitting on a light card is left alone.
  (function () {
    var hosts = document.querySelectorAll('[data-ntx-embed-light]');
    if (!hosts.length) return;

    function parseColor(value) {
      var m = /rgba?\(([^)]+)\)/.exec(value || '');
      if (!m) return null;
      var parts = m[1].split(',').map(parseFloat);
      if (parts.length > 3 && parts[3] === 0) return null;
      return parts;
    }

    function isLight(rgb) {
      return (rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114) > 140;
    }

    function backdropIsLight(el, host) {
      for (var node = el; node && node !== host; node = node.parentElement) {
        var bg = parseColor(getComputedStyle(node).backgroundColor);
        if (bg) return isLight(bg);
      }
      return false;
    }

    function lighten(host) {
      host.querySelectorAll('*').forEach(function (el) {
        if (el.children.length || !el.textContent.trim()) return;
        var color = parseColor(getComputedStyle(el).color);
        if (!color || isLight(color)) return;
        if (backdropIsLight(el, host)) return;
        el.style.color = 'var(--text-primary)';
      });
    }

    hosts.forEach(function (host) {
      var queued = false;
      function run() {
        queued = false;
        lighten(host);
      }
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(run, 120);
      }).observe(host, { childList: true, subtree: true });
      run();
    });
  })();

  // Category gallery pagination (10 per page by default)
  (function () {
    var root = document.querySelector('[data-gal-page]');
    if (!root) return;

    var per = parseInt(root.getAttribute('data-per') || '10', 10);
    if (!per || per < 1) per = 10;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gal-item]'));
    var pager = root.querySelector('[data-gal-pager]');
    if (!items.length || !pager) return;

    var totalPages = Math.ceil(items.length / per);
    if (totalPages <= 1) {
      pager.hidden = true;
      return;
    }

    function currentPage() {
      var params = new URLSearchParams(window.location.search);
      var p = parseInt(params.get('page') || '1', 10);
      if (!p || p < 1) p = 1;
      if (p > totalPages) p = totalPages;
      return p;
    }

    function setPage(page, push) {
      if (page < 1) page = 1;
      if (page > totalPages) page = totalPages;

      items.forEach(function (item, i) {
        var show = i >= (page - 1) * per && i < page * per;
        item.classList.toggle('hide', !show);
      });

      renderPager(page);

      if (push) {
        var url = new URL(window.location.href);
        if (page <= 1) url.searchParams.delete('page');
        else url.searchParams.set('page', String(page));
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }

      var hero = root.querySelector('.p-hero');
      if (push && hero) {
        var top = hero.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    function renderPager(page) {
      pager.hidden = false;
      pager.innerHTML = '';

      function addBtn(label, target, opts) {
        opts = opts || {};
        var el = document.createElement(opts.disabled || opts.current ? 'span' : 'a');
        el.className = 'gal-page-btn';
        el.textContent = label;
        if (opts.current) el.classList.add('is-on');
        if (opts.disabled) el.classList.add('is-disabled');
        if (el.tagName === 'A') {
          el.href = '#';
          el.addEventListener('click', function (e) {
            e.preventDefault();
            setPage(target, true);
          });
        }
        pager.appendChild(el);
      }

      addBtn('Prev', page - 1, { disabled: page <= 1 });

      var status = document.createElement('span');
      status.className = 'gal-page-status';
      status.textContent = 'Page ' + page + ' of ' + totalPages;
      pager.appendChild(status);

      // Compact page numbers
      var windowSize = 5;
      var start = Math.max(1, page - Math.floor(windowSize / 2));
      var end = Math.min(totalPages, start + windowSize - 1);
      start = Math.max(1, end - windowSize + 1);

      if (start > 1) {
        addBtn('1', 1, { current: page === 1 });
        if (start > 2) {
          var dots = document.createElement('span');
          dots.className = 'gal-page-status';
          dots.textContent = '…';
          pager.appendChild(dots);
        }
      }

      for (var i = start; i <= end; i++) {
        addBtn(String(i), i, { current: i === page });
      }

      if (end < totalPages) {
        if (end < totalPages - 1) {
          var dots2 = document.createElement('span');
          dots2.className = 'gal-page-status';
          dots2.textContent = '…';
          pager.appendChild(dots2);
        }
        addBtn(String(totalPages), totalPages, { current: page === totalPages });
      }

      addBtn('Next', page + 1, { disabled: page >= totalPages });
    }

    setPage(currentPage(), false);
  })();
})();
